export default "__VITE_ASSET__Bvh4zdH5__"